import { withProps } from 'recompose'
import { defineMessages } from 'react-intl'
import { LOAN_TYPE } from '../../../../../constants/loan'

const typeMessages = defineMessages({
  firstCel: {
    id: 'Mortgages.loans.type.firstCel',
    defaultMessage: 'The main (larger)',
  },
  secondCel: {
    id: 'Mortgages.loans.type.secondCel',
    defaultMessage: 'Second loan',
  },
  heloc: {
    id: 'Mortgages.loans.type.heloc',
    defaultMessage: 'HELOC',
  },
})

const loanTypes = [
  {
    key: 'firstCel',
    value: LOAN_TYPE.FIRST_CEL,
  },
  {
    key: 'secondCel',
    value: LOAN_TYPE.SECOND_CEL,
  },
  {
    key: 'heloc',
    value: LOAN_TYPE.HELOC,
  },
]

export const withTranslatedLoanTypes = withProps(({ intl }) => ({
  typeOptions: loanTypes.map(type => ({
    loanType: type.value,
    value: intl.formatMessage(typeMessages[type.key]),
  })),
}))
